import React from "react";

import LogsFilter from "~/pages/Logs/components/LogsFilter";

import { emailLogsFilterFields } from "./fields";

const EmailLogsFilter = () => <LogsFilter fields={emailLogsFilterFields} />;

export default EmailLogsFilter;
